import { createColumnHelper } from "@tanstack/react-table";
import { AllFlightView } from "../../../../../enum/flights/FlightTableEnum";
import { ensureArray } from "../../../../../utils/common/CommonHelperFunctions";
import { formatGroundHandler } from "../../../../../utils/flights/FlightHelperFunctions";
import {
  getDelayDuration,
  getFlightSecurityLevelAbbreviation,
  getTableLegLabel,
} from "../../../../../utils/flights/flight-table/FlightTableHelper";
import { DelayCode } from "../DelayCode";

const columnHelper = createColumnHelper<AllFlightView>();

export const allFlightTableColumns = [
  columnHelper.accessor((row) => row.displayStatus ?? "", {
    id: "common.status",
    header: "STAT",
    size: 70,
  }),
  columnHelper.accessor((row) => getTableLegLabel(row.type) ?? "", {
    id: "common.leg type",
    header: "TYPE",
    size: 70,
  }),
  columnHelper.accessor((row) => row.flightNumber ?? "", {
    id: "common.flight number",
    header: "FLT",
    size: 80,
  }),
  columnHelper.accessor((row) => row.origin ?? "", {
    id: "common.origin",
    header: "ORIG",
    size: 80,
  }),
  columnHelper.accessor((row) => row.destination ?? "", {
    id: "common.destination",
    header: "DEST",
    size: 80,
  }),
  columnHelper.accessor((row) => row.blockTime ?? "", {
    id: "common.block time",
    header: "TIME",
    size: 100,
  }),
  columnHelper.accessor((row) => row.scheduledBlockTime ?? "", {
    id: "common.scheduled block time.kpi",
    header: "SCH BLK TIME",
    size: 180,
  }),
  columnHelper.accessor((row) => row.estimatedBlockTime ?? "", {
    id: "common.estimated block time.kpi",
    header: "EST BLK TIME",
    size: 180,
  }),
  columnHelper.accessor((row) => row.actualBlockTime ?? "", {
    id: "common.actual block time.kpi",
    header: "ACT BLK TIME",
    size: 180,
  }),
  columnHelper.accessor((row) => row.flightDuration ?? "", {
    id: "common.flight time.kpi",
    header: "FLT DUR",
    size: 150,
  }),
  columnHelper.accessor(
    (row) => getFlightSecurityLevelAbbreviation(row.flightSecurityLevel),
    {
      id: "common.flight security level",
      header: "D/I",
      size: 60,
    }
  ),
  columnHelper.accessor((row) => row.aircraftType ?? "", {
    id: "common.aircraft type",
    header: "AC TYPE",
    size: 100,
  }),
  columnHelper.accessor((row) => row.aircraftRegistration ?? "", {
    id: "common.aircraft registration",
    header: "AC REG",
    size: 100,
  }),
  columnHelper.accessor((row) => row.callSign ?? "", {
    id: "common.call Sign",
    header: "CS",
    size: 80,
  }),
  columnHelper.accessor((row) => row.terminal ?? "", {
    id: "common.terminal.kpi",
    header: "TML",
    size: 100,
  }),
  columnHelper.accessor((row) => row.Runway ?? "", {
    id: "common.runway",
    header: "RWY",
    size: 100,
  }),
  columnHelper.accessor((row) => row.atmCategory ?? "", {
    id: "common.atm.kpi",
    header: "ATM",
    size: 80,
  }),
  columnHelper.accessor((row) => row.pax ?? "", {
    id: "common.pax.kpi",
    header: "PAX",
    size: 80,
  }),
  columnHelper.accessor((row) => row.stand ?? "", {
    id: "common.stand",
    header: "STAND",
    size: 90,
  }),
  columnHelper.accessor((row) => row.gate ?? "", {
    id: "common.gate",
    header: "GATE",
    size: 80,
  }),
  columnHelper.accessor((row) => getDelayDuration(row.delayDurations), {
    id: "common.delay durations",
    header: "DELAY",
    size: 150,
  }),
  columnHelper.accessor((row) => ensureArray<string>(row.delayCodes), {
    id: "common.delay codes",
    header: "DLY C",
    size: 150,
    cell: (info) => {
      const codes = info.getValue();
      const durations = ensureArray<string>(info.row.original?.delayDurations);
      return DelayCode({ codes, durations });
    },
    filterFn: (row, columnId, filterValue) => {
      const codesList = row
        .getValue<string[]>(columnId)
        .join(",")
        .toLowerCase();

      const searchValue = String(filterValue ?? "").toLowerCase();
      return codesList.includes(searchValue);
    },
  }),
  columnHelper.accessor((row) => row.airline ?? "", {
    id: "common.airline",
    header: "AL",
    size: 120,
  }),
  columnHelper.accessor((row) => row.routing ?? "", {
    id: "common.routing",
    header: "RTE",
    size: 150,
  }),
  columnHelper.accessor((row) => formatGroundHandler(row.groundHandler), {
    id: "common.ground handler.kpi",
    header: "GHA",
    size: 150,
  }),
];
